import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { isLegacyTitle, NAV_GROUP_LABELS, navGroupOf } from "./route-data";

// Routes set a short `title` ("Parts"); this composes the document title from it and the
// route's navGroup: "JTMS | Engineering - Parts". Provided in core.ts as the TitleStrategy.
@Injectable()
export class JtmsTitleStrategy extends TitleStrategy {
  readonly #title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.#title.setTitle(composeTitle(snapshot, this.buildTitle(snapshot)));
  }
}

export function composeTitle(snapshot: RouterStateSnapshot, page: string | undefined): string {
  if (!page) return "JTMS";
  if (isLegacyTitle(page)) return page;

  const group = navGroupOf(snapshot.root);
  return group ? `JTMS | ${NAV_GROUP_LABELS[group]} - ${page}` : `JTMS | ${page}`;
}
